import React from "react";
import PrimaryButton from "web/react/components/buttons/primary-button/primary-button";
import WebToAppCampaign from "web/react/components/web-to-app-campaign/web-to-app-campaign";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import globals from "web/script/modules/globals";
import styles from "./related-products-show-more.css";

interface RelatedProductsSectionProp {
    view_more_url: string;
    product_is_instock?: boolean;
    id: string;
    isAffiliate: boolean;
}

export function RelatedProductsShowMoreKevelEnabled(
    section: RelatedProductsSectionProp
): JSX.Element {
    const productIsInstock = section.product_is_instock != null && section.product_is_instock;

    function beforeOnClick(): void {
        analytics.event("navigation", "show_more_related", "show_feed");
    }

    const analyticsEventLabel = productIsInstock ? "is_related_show_more" : "oos_related_show_more";
    const campaignAction = productIsInstock
        ? "is_related_show_more_click"
        : "oos_related_show_more_click";

    function onCampaignNotActive(): void {
        // go to the related products feed
        globals.window.location.href = section.view_more_url;
    }

    return (
        <WebToAppCampaign
            options={{ action: campaignAction, isAffiliate: section.isAffiliate }}
            onCampaignNotActive={onCampaignNotActive}
            continueOptionHref={section.view_more_url}
            analyticsEventLabel={analyticsEventLabel}
            beforeOnClick={beforeOnClick}
            id={section.id}
        >
            <PrimaryButton href={section.view_more_url} className={styles.showMoreButton}>
                {gettext("product.related_products.show_me_more")}
            </PrimaryButton>
        </WebToAppCampaign>
    );
}

export default RelatedProductsShowMoreKevelEnabled;
